/*
 * Open Golden Race Overlay
 */
import jQuery from 'jquery';
import MessageBusTopics from '../../common/MessageBusTopics';


var appendGoldenRaceHashToURL = function () {
    jQuery('#nav-horse-racing-goldenrace > a, #nav-golden-race').addClass('non-route');

    jQuery('.openGoldenRace, #nav-horse-racing-goldenrace, #nav-golden-race').on('click', (e) => {
        e.preventDefault();
        window.location.hash='#goldenrace';
    });
};

/**
 * Starts the hash listener
 *
 * @returns {void}
 *
 * @private
 */
var api = {
    init: function() {
        window.WH.messageBus.subscribe(MessageBusTopics.NAVIGATION_PAGE_CHANGED, appendGoldenRaceHashToURL);
    },
};

export default api;